"use client";

import { useState, useEffect } from "react";
import { Link } from "@/i18n/navigation";
import { motion, AnimatePresence } from "framer-motion";
import { Icon } from "./Icon";

export function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Show after a short delay
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie-consent", "true");
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          className="cookie-banner"
        >
          <div className="container cookie-container">
            <div className="cookie-content">
              <div className="cookie-icon">
                <Icon name="check" />
              </div>
              <div className="cookie-text">
                <p>
                  We use cookies to provide you with a better browsing experience, personalize content, serve targeted advertisements, and analyze site traffic. 
                  By clicking "Accept", you consent to our use of cookies. If you do not wish to allow cookies, you can disable them by clicking "Decline". 
                  Read our <Link href="/privacy-policy">Privacy Policy</Link> and <Link href="/cookies-policy">Cookies Policy</Link> for more details.
                </p>
              </div>
            </div>
            <div className="cookie-actions">
              <button onClick={accept} className="btn btn--brand">
                Accept All
              </button>
              <button onClick={() => setIsVisible(false)} className="btn btn--ghost">
                Decline
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
